import React from 'react';
import {useEffect, useState, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "player-components";
import PWAPrompt from 'react-ios-pwa-prompt'
import platform from 'platform';

import { selectServiceWorkerRegistration, selectServiceWorkerInitialized, selectServiceWorkerUpdated, selectLatestServiceWorkerLoaded, setLatestServiceWorkerLoaded } from '../../features/offline/offlineSlice';
import {setDismissedOfflineNotification, selectDismissedOfflineNotification} from '../../features/ui/uiSlice';


import { BellIcon } from '@heroicons/react/24/outline'

const OfflineVersioning = () => {

    const dispatch = useDispatch();
    const serviceWorkerRegistration = useSelector(selectServiceWorkerRegistration);
    const serviceWorkerInitialized = useSelector(selectServiceWorkerInitialized);
    const serviceWorkerUpdated = useSelector(selectServiceWorkerUpdated);
    const dismissedOfflineNotification = useSelector(selectDismissedOfflineNotification);

    const os = useRef(platform.os);

    const dismissOfflineNotification = () => {
        dispatch(setDismissedOfflineNotification(true));
    }
    const updateServiceWorker = () => {
        const registrationWaiting = serviceWorkerRegistration.waiting;
        if (registrationWaiting) {
          registrationWaiting.postMessage({ type: 'SKIP_WAITING' });
          registrationWaiting.addEventListener('statechange', e => {
            if (e.target.state === 'activated') {
                dispatch(setLatestServiceWorkerLoaded(true));
                // here we reload the page to activate the new version
                // We run any migration scripts we need here to patch application states
              window.location.reload();
            }
          });
        }
      };


return (
    <>
        <PWAPrompt />
        {os.current.family?.includes('iOS') ? (
            <PWAPrompt />
        ) : (
            // Modal is not rendered anymore
            <></>
        )}

        {/* Commented-out or removed the offline notification Modal */}

        {/* <Modal 
            isOpen={false}
            title="Did you know?"
            content={<div className="w-full">
            <p>You can visit this site and play back music even when you are offline!</p>
            </div>}
            confirmLabel="Okay"
            icon={<BellIcon className="h-6 w-6 text-primary" aria-hidden="true" />}
            onConfirm={updateServiceWorker}
            onClose={()=>{}}
        /> */}

        {/*
            pgw 17-may-2026
            Do not show the old service-worker update modal here.
            App version updates are now driven by src/utils/appVersionCheck.js,
            which shows the required OK / "No. Check again after X minutes" dialog.
        */}
    </>
);
}

export default OfflineVersioning;